<template>
  <div>
    <PageLoader />
    <v-app id="app">
      <AppHeader
        v-if="
          $vuetify.breakpoint.name == 'xs'
        "
      />
      <mainHeader
        v-if="
          $vuetify.breakpoint.name !== 'xs' "
      />

      <div
        :style="{
          'padding-top': $vuetify.breakpoint.name == 'xs' ? '49px' : '99px',
        }"
      >
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <!-- <span style="min-height: 100vh">
        <router-view :key="$route.fullPath" v-bind:storage="sideNav" />
      </span> -->
      <AppFooter/>
    </v-app>
  </div>
</template>
<script>
import AppHeader from "./layout/AppHeader";
import mainHeader from "./layout/Default";
import AppFooter from "./layout/appFooter";

import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";

export default {
  data() {
    return {
      sideNav: false,
    };
  },
  components: {
    AppHeader,
    mainHeader,
    AppFooter
  },
  beforeMount() {},
  methods: {},
};
</script>
